import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { CombosHomeService } from "./combos-home.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-combos-home',
  templateUrl: './combos-home.component.html',
  styleUrls: ['./combos-home.component.scss']
})
export class CombosHomeComponent implements OnInit {

  isComboShow = true;
  comboName = constants.COMBOS_ID;
  bonusesList:any  = [];
  combosList:any = [];
  
  //Constructor del componente
  constructor(public LANG:CommonUtilitiesService, private combosHomeService:CombosHomeService, private _router: Router) { }

  /**
   * Description: Método que inicializa las variables del componente
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    this.loadRecommended();
  }

  /**
   * Description: Método que cambia de tab por medio de los botones de combos y bonos
   * Autor: Diego Diaz
   * @param id identificador del tab que se desa mostrar
   * @return N/A
   */
  switchTab(id){
    if(id == this.comboName){
      this.isComboShow = true;
    }else{
      this.isComboShow = false;
    }
  }

  /**
   * Description: Método que obtiene el valor del id de combo
   * Autor: Diego Diaz
   * @param N/A
   * @return Valor de la variable COMBO
   */
  getComboId(){
    return this.comboName;
  }

  /**
   * Description: Método que obtiene los bonos y combos recomendados
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  loadRecommended(){
    //Obtiene los combos recomendados
    this.combosHomeService.getCombosList(1).subscribe((dataInfo => {
      if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        
        let counter = 0;
        for (var k in dataInfo['obj']) {
          if(counter >=2){
            break;
          }
          this.combosList.push(dataInfo['obj'][k]);
          counter++;
        }

      }
    }),
    (err) => {
      this.combosList = [];
    });
    //Obtiene los bonos recomendados
    this.combosHomeService.getBonusesList(1).subscribe((dataInfo => {
      if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        
        let counter = 0;
        for (var k in dataInfo['obj']) {
          if(counter >=2){
            break;
          }
          dataInfo['obj'][k].nslist = dataInfo['obj'][k].socialNet.split("-");
          this.bonusesList.push(dataInfo['obj'][k]);
          counter++;
        }
      }
    }),
    (err) => {
      this.bonusesList = [];
    });
  }

    /**
   * Description: Método que muestra el wizard de pagos
   * Autor: Diego Diaz
   * @param comboJson información del Combo/bono a comprar
   * @return N/A
   */
  showPaymentWizard(comboJson){
    localStorage.setItem("shoppingCart", JSON.stringify(comboJson));
    this._router.navigate([constants.ROUTE_URL_PAYMENT_COMBOS]);    
  }
}
